import React from "react";
import axios from "axios";
import ResultCard from "../../components/Cards/ResultCard/ResultCard";

//React Router
import { useParams } from "react-router-dom";

import "./categoryProducts.scss";
import { Link } from "react-router-dom";

const CategoryProducts = () => {
  const { category } = useParams();
  const [products, setProducts] = React.useState(null);

  //API PRODUCTOS
  React.useEffect(() => {
    const fetchProductResult = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/category/${category}`
        );
        setProducts(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchProductResult();
  }, [category]);

  return products ? (
    <div className="resultPage__container">
      {products.length === 0 ? (
        <p className="emptyResults">
          Esta categoría no tiene productos disponibles.{" "}
          <Link to="/home" style={{ color: "#f0572d" }}>
            Vuelve a buscar
          </Link>
        </p>
      ) : (
        <section className="productCards">
          <h2>
            Vehículos disponibles en la categoría {products[0].category.title}
          </h2>
          <div className="results__container">
            {products.map((product) => (
              <ResultCard data={product} key={product.title} />
            ))}
          </div>
        </section>
      )}
    </div>
  ) : (
    <div className="resultPage__container">
      <h2 className="product__loading">Loading data...</h2>/
    </div>
  );
};

export default CategoryProducts;
